module.exports = __webpack_public_path__ + "images/home/product/video-button-1b99ad256fcabd8f996c7a817c619ed8.png";